export const vaxhubVideoTutorial = {
  title: "วิธีการสั่งจองวัคซีนออนไลน์",
  subtitle: "วิดีโอแนะนำขั้นตอนการสั่งจองวัคซีนด้วยตัวเอง",
  stepsTitle: "ขั้นตอนการจองวัคซีน",
  videoSrc: "https://vaxhub.dld.go.th/videos/VaccineReservation.mp4",
  poster: "/videos/VaxhubTutorialCover.png",
  posterTime: null,
  allVideosUrl: "/usermanual.pdf",
  steps: [
    "เข้าสู่ระบบ/ลงทะเบียน เพื่อใช้งานระบบ",
    "เลือกเมนูสั่งจองวัคซีน และกดปุ่มสร้างใบจองใหม่",
    "เลือกรอบการจอง จุดรับวัคซีน และกรอกข้อมูลการติดต่อ",
    "กดสร้างใบจองวัคซีนใหม่",
    "เลือกรายการวัคซีน พร้อมระบุจำนวนวัคซีนที่ต้องการสั่งจอง (ทำซ้ำจนครบทุกรายการวัคซีนที่ต้องการสั่งจอง)",
    "กดบันทึกใบจองวัคซีน ระบบจะส่งอีเมล์ยืนยันการสั่งจองวัคซีนให้ที่อีเมล์ที่กรอกไว้",
    "สามารถพิมพ์ใบจองวัคซีน หรือดาวน์โหลดใบจองวัคซีน (PDF) ได้ที่หน้าจอระบบ",
  ],
};
